import registrations from './registrations'
import pedagogic from './pedagogic'
import audiovisual from './audiovisual'
import uptos3 from './uptos3'
import backoffice from './backoffice'
import reports from './reports'
import attendance from './attendance'
import dashboard from './dashboard'
export default [...dashboard,...registrations, ...pedagogic, ...audiovisual, ...reports, ...attendance, ...uptos3, ...backoffice]